import React from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ServiceStatusTable from "./ServiceStatusTable";
import * as S from "./style";

interface ServiceStatus {
  name: string;
  url: string;
  ip_address?: string;
  status: string;
  tag?: string;
  gpu_enabled?: boolean;
  http_code?: number | null;
  latency_ms?: number | null;
  last_checked: string;
  error?: string | null;
}

interface SystemHealthPageProps {
  services: ServiceStatus[];
  loading: boolean;
  error: string | null;
  pollInterval: number;
  onRefresh: () => void;
}

const SystemHealthPage: React.FC<SystemHealthPageProps> = ({
  services,
  loading,
  error,
  pollInterval,
  onRefresh,
}) => {
  const upCount = services.filter((s) => s.status === "up").length;
  const downCount = services.filter((s) => s.status !== "up").length;

  return (
    <Box>
      {/* Header */}
      <Box sx={S.StyledHeaderBox}>
        <Box>
          <Typography sx={S.StyledHeaderTitle}>System Health</Typography>
          <Typography sx={S.StyledHeaderSubtitle}>
            {upCount} service{upCount !== 1 ? "s" : ""} up
            {downCount > 0 && `, ${downCount} down`}
            {" · "}polling every {pollInterval / 1000}s
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <RefreshIcon />
            )
          }
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh
        </Button>
      </Box>

      {/* Error banner */}
      {error && <S.StyledErrorPaper>{error}</S.StyledErrorPaper>}

      {/* Table */}
      <ServiceStatusTable services={services} loading={loading} />
    </Box>
  );
};

export default SystemHealthPage;
